// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_t0-0";